/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../../environments/environment";
import { TokenStorageService } from '../../../services/token-storage.service';
const API_URL = environment.apiUrl + 'question-answer';
@Injectable(
  {
    providedIn: "root"
  }
)
export class QuestionService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }
  getQuestionAnswerList(query): Observable<any> {
    return this.http.get<any>(API_URL + query, this.httpOptions);
  }
  getQuestionAnswerDetails(id: string) {
    return this.http.get<any>(`${API_URL}/${id}`, this.httpOptions);
  }
  addQuestionAnswer(questionAnswer) {
    return this.http.post<any>(API_URL, questionAnswer, this.httpOptions);
  }
  updateQuestionAnswer(id: string, questionAnswer): Observable<any> {
    return this.http.put(API_URL + '/' + id, questionAnswer, this.httpOptions);
  }

}
